export interface IFaqQuestion {
  id: string
  question: string
  answer: string
  comment?: string
  videos?: Array<{
    id: string
    title: string
  }>
}

export interface IFaqCategory {
  id: string
  title: string
  meta_category: string
  faq: IFaqQuestion[]
  videos?: IFaqCategoryVideo[]
}

export interface IFaqCategoryVideo {
  id: string
  title: string
}

export const faqs: IFaqCategory[] = [
  {
    id: "about-better",
    title: "About Better",
    meta_category: "What Better offers",
    faq: [
      {
        id: "why-choose-better",
        question: "Why choose Better?",
        answer:
          '<p>When you work with us, you get a team that’s committed to providing a fast, transparent digital mortgage experience backed by superior customer support.</p><p>As a Better customer, you can expect:</p><ul>  <li>Industry-leading rates quoted in just 3 seconds</li>  <li>Initial approval in 3 minutes</li>  <li>100% online application process</li>  <li>0% loan officer commission &mdash; <a href="/content/5-reasons-why-loan-officer-commission-is-bulls-t/" target="_blank" rel="noopener noreferrer">read more about why</a></li>  <li>A team that provides support, not sales</li></ul>',
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        id: "is-better-a-direct-lender",
        question: "Is Better a direct lender?",
        answer:
          "<p>Yes, we are. We work with all our borrowers from application through funding of the loan, which creates a seamless and consistent experience.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        id: "will-better-service-my-mortgage",
        question: "Will Better service my mortgage?",
        answer:
          "<p>No. Once your loan is funded, Better will transfer ownership of your loan to an investor who will provide servicing.</p><p>During the application process, we will match you to a reputable, quality investor that provides the right type of loan and servicing for your situation. Your loan officer can tell you which investor we’re matching you to and answer any questions.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        comment: "ADDING_NEW_STATES",
        id: "does-better-offer-mortgages-in-my-state",
        question: "Does Better offer mortgages in my state?",
        answer:
          "<p>We currently originate mortgages in the following states:</p><ul><li>Alaska</li> <li>Alabama</li> <li>Arizona</li> <li>Arkansas</li> <li>California</li> <li>Colorado</li> <li>Connecticut</li> <li>Delaware</li> <li>District Of Columbia</li> <li>Florida</li> <li>Georgia</li> <li>Illinois</li> <li>Iowa</li> <li>Kansas</li> <li>Kentucky</li> <li>Louisiana</li> <li>Maine</li> <li>Michigan</li> <li>Mississippi</li> <li>North Carolina</li> <li>North Dakota</li> <li>New Jersey</li> <li>Oklahoma</li> <li>Oregon</li> <li>Pennsylvania</li> <li>South Dakota</li> <li>Tennessee</li> <li>Texas</li> <li>Washington</li> <li>West Virginia</li> <li>Wisconsin</li></ul><p>We’re working on expanding into more states in the near future.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
    ],
    videos: [
      {
        id: "who-is-better",
        title: "A quick overview",
      },
      {
        id: "loan-estimates",
        title: "Why are loan estimates so important",
      },
    ],
  },
  {
    id: "loan-types-and-products",
    title: "Loan types and products",
    meta_category: "",
    faq: [
      {
        id: "what-types-of-mortgages-does-better-offer",
        question: "What types of mortgages does Better offer?",
        answer:
          "<p>We currently offer fixed rate FHA loans and both fixed and adjustable rates for conventional and jumbo loans. We finance properties including:</p><ul>  <li>Single-family homes</li>  <li>Multi-family homes <i>(up to four units)</i></li>  <li>Townhouses</li>  <li>Condominiums</li>  <li>Planned Unit Development (PUD)</li></ul><p>At this time we do not offer mortgages for:</p><ul>  <li>Manufactured/modular homes</li>  <li>Multi-family homes <i>(five or more units)</i></li>  <li>Co-ops</li>  <li>Mixed-use properties</li></ul>",
        videos: [
          {
            id: "fixed-vs-adjustable",
            title: "The difference between “fixed rate” and “adjustable”",
          },
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        id: "do-you-offer-loans-for-investment-properties",
        question: "Do you offer loans for investment properties?",
        answer: "<p>Yes, we do offer loans for investment properties.</p>",
      },
      {
        id: "do-you-offer-va-or-usda-loans",
        question: "Do you offer VA or USDA loans?",
        answer: "<p>No, we do not offer VA or USDA loans at this time.</p>",
      },
      {
        id: "do-you-offer-construction-or-commercial-loans",
        question: "Do you offer construction or commercial loans?",
        answer:
          "<p>No, we do not offer construction or commercial loans at this time.</p>",
      },
      {
        id: "do-you-offer-helocs-or-second-mortgages",
        question: "Do you offer HELOCs or second mortgages?",
        answer:
          "<p>No, we do not offer home equity lines of credit (HELOCs) or second mortgages at this time.</p>",
      },
      {
        id: "do-you-offer-texas-cash-out-home-equity-loans",
        question: "Do you offer Texas Cash Out Home Equity Loans?",
        answer:
          "<p>No, we do not offer cash-out mortgages on primary residences in Texas. Additionally, we are unable to offer refinancing on properties secured, or previously secured, by a Texas Cash Out Home Equity Loan.</p><p>A Texas Cash Out Home Equity Loan is a refinance where you take equity out of your home in the form of cash on your primary residence, or homestead.  In other words, you refinance and get cash back, reducing the amount of equity you have in your home.</p>",
      },
      {
        id:
          "do-you-offer-loans-for-the-purchase-of-foreclosure-or-bank-owned-properties",
        question:
          "Do you offer loans for the purchase of foreclosure or bank-owned properties?",
        answer:
          "<p>No, we do not offer loans for properties that are currently owned by a bank, or in the process of foreclosure or short sale.</p>",
      },
      {
        id: "do-you-refinance-homes-that-are-held-in-llcs",
        question: "Do you refinance homes that are held in LLCs?",
        answer:
          "<p>We do not refinance homes that are currently held in a LLC. If you want to remove the home from the LLC before moving forward, there is a conventional loan mandatory waiting period of 6 months before we are able to move forward.</p>",
      },
    ],
    videos: [
      {
        id: "points-and-credits",
        title: "What are points and credits?",
      },
    ],
  },
  {
    id: "better-guarantee",
    title: "Better Price Guarantee",
    meta_category: "All about pricing",
    faq: [
      {
        id: "whats-the-better-price-guarantee",
        question: "What's the Better Price Guarantee?",
        answer:
          "<p>We will beat a competitor's offer by at least $1000 or we’ll pay you $1000.<p><p>If you think another lender has a more competitive price, send us their Loan Estimate within 3 business days from the date on the Loan Estimate.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "what-is-a-loan-estimate",
        question: "What is a Loan Estimate?",
        answer:
          "<p>This 3-page form provides you with important information, including the estimated interest rate, monthly payment, and closing costs of your loan. It’s a standard form that all lenders are required by law to provide you within three business days of submitting your application.</p><p>A Loan Estimate is important for comparing pricing across lenders, and because this document commits a lender to certain fee tolerances it reduces the risk of a bait-and-switch offer.</p>",
        videos: [
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "how-do-we-keep-our-prices-so-low",
        question: "How do we keep our prices so low?",
        answer:
          "<p>We use innovative technology to dramatically lower our costs and then guarantee those savings to you—this isn’t a marketing ploy or a flash sale.</p>",
      },
      {
        id: "whats-the-fine-print",
        question: "What's the fine print?",
        answer:
          '<ol><li>Offer is only to conforming loan product customers who do not have a rate lock with Better Mortgage in the sixty (60) days prior to the date of the presented loan estimate from another lender.</li><li>"At least $1,000 better for the same rate and terms" refers to the Better Loan Estimate being at least $1,000 less in closing costs at the same rate and for the same loan terms, excluding property taxes and insurance (the fees listed in Sections E through H on your Loan Estimate), as the closing costs on the Loan Estimate from the other Lender. For purchase transactions using the seller’s title company, comparisons will also exclude title fees.</li><li>Better Mortgage may, in its sole discretion, accept LE proxies (e.g., rate sheets from other lenders) provided the rate and terms from the competitive lender are readily available to the general public.</li><li>The Loan Estimate must be dated within 3 business days from its date of submission to Better Mortgage.</li><li>Offer is only valid in states where Better Mortgage is currently originating loans. It includes all conforming loan products on single-family residences, condominiums and PUDs.</li><li>Offer is not available for refinances of loans originated by Better within 6 months of funding date.</li><li>To claim offer proceeds borrower must (1) fund their loan with lender that Better Mortgage could not beat by $1,000 in closing costs using the same LE presented to Better to initiate this promotion; and (2) present closing disclosure and final note from funded loan within thirty (30) days of closing.</li><li>Amounts on the Loan Estimate may still vary within regulatory tolerances from the closing disclosure based on findings in underwriting, and all loans are subject to credit approval.</li><li>Offer cannot be combined with any other promotion. Offer is invalid if the borrower submits an LE from a lender with a rate that is not publicly available (e.g., requiring a minimum amount of assets under management). Each borrower make only take advantage of this offer once per loan application.</li><li>Better Mortgage reserves the right to rescind or modify the terms of this offer without prior notice.</li></ol>',
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
    ],
  },
  {
    id: "rates",
    title: "Rates",
    meta_category: "",
    faq: [
      {
        id: "how-does-better-detemine-my-mortgage-rate",
        question: "How does Better determine my mortgage rate?",
        answer:
          "<p>We use technology to consider a wide range of factors — such as market conditions, your credit history, and your property characteristics — to find the best possible rates and options available to you from a variety of investors.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        id: "will-i-get-the-same-rate-i-was-quoted",
        question: "Will I get the same rate I was quoted?",
        answer:
          "<p>Yes. If you provide accurate information, the rate quote you receive will be available to you in almost all cases. This is true even if you get a quote on a third-party site like Zillow or LendingTree.</p><p>To get the most accurate rate quote, we suggest applying right here on our site — it takes just 3 minutes to get pre-approved and won’t affect your credit score. Keep in mind that rates change constantly, so the sooner you apply the sooner you can lock in your rate.</p>",
        videos: [
          {
            id: "shopping-for-a-home",
            title: "I need to get pre-approved",
          },
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
        ],
      },
      {
        id: "what-is-included-in-the-monthly-payment",
        question: "What is included in the monthly payment?",
        answer:
          "<p>When you get a rate quote on our site, the monthly payment shown includes the principal and interest of the loan. You will also need to pay taxes and insurance, which vary based on location and other factors.</p>",
      },
      {
        id: "what-are-points-and-credits",
        question: "What are points and credits?",
        answer:
          '<p>Points represent a percentage of your loan amount (1 point = 1&#37;). You might choose to pay points at closing in exchange for a lower interest rate on the loan. In other words, by pre-paying some interest, you are “buying down” your rate.</p><p>Conversely, you might choose to receive a credit (or rebate) at closing to help cover other costs and fees. This would correspond to a higher interest rate on the loan.</p><p>Not sure what to do? <a href="/content/no-cost-mortgage/" target="_blank" rel="noopener noreferrer">Try our interactive calculator</a>.</p>',
        videos: [
          {
            id: "points-and-credits",
            title: "What are points and credits?",
          },
        ],
      },
      {
        id: "how-do-i-get-one-eigth-off",
        question: "How do I get an 1/8th off my rate?",
        answer:
          "<p>If you use a real estate agent referred to you by Better Real Estate and choose to use Better Mortgage Corporation as your lender, you may be eligible for a discount of 1/8th of your interest rate on your purchase transaction. Call us to find out more about the program.</p>",
      },
      {
        id: "whats-the-fine-print",
        question: "What's the fine print to get 1/8th off my rate?",
        answer:
          "<ol><li>Offer is open to conforming loan product customers who have (a) entered a purchase contract on a home using a real estate agent referred by Better Mortgage’s affiliated real estate brokerage, Finche, LLC, dba BRE, Better Home Services and Better Real Estate(“Better Real Estate”); and (b) closed a mortgage loan on said home with Better Mortgage Corporation.</li> <li>”1/8th off your rate” refers to the percentage point discount from the interest rate you locked with Better Mortgage Corporation if you use a real estate agent referred to you by Better Real Estate. Use of the agent must be confirmed by Better Real Estate in a manner satisfactory to Better Mortgage Corporation in its sole discretion prior to issuance of the Closing Disclosure on the loan.  The reduced rate will appear on the Closing Disclosure.</li> <li>Offer is only valid in states where Better Mortgage Corporation is currently originating loans. It includes all conforming loan products on single-family residences, condominiums and PUDs.</li> <li>Offer is not available for refinances.</li> <li>To claim offer proceeds you must (1) lock a mortgage loan rate on the purchase of a primary residential property with Better Mortgage; (2) have your use of the Better Real Estate referred agent confirmed by Finche prior to issuance of the Closing Disclosure to the satisfaction of Better Mortgage in its sole discretion; and (3) close on the mortgage loan with Better Mortgage Corporation.</li> <li>The rate locked initially may still vary within regulatory tolerances from the rate available to you at closing based on findings in underwriting, and all loans are subject to credit approval. The reduction will be taken from the rate available to you at the time of issuance of the closing disclosure.</li> <li> Better Mortgage reserves the right to rescind or modify the terms of this offer without prior notice.</li> </ol>",
      },
    ],
    videos: [
      {
        id: "fixed-vs-adjustable",
        title: "The difference between “fixed rate” and “adjustable”",
      },
    ],
  },
  {
    id: "locking",
    title: "Locking",
    meta_category: "",
    faq: [
      {
        id: "what-exactly-does-locking-mean",
        question: 'What exactly does "locking" mean?',
        answer:
          "After you lock, we’ll hold your rate for you while we work together on the loan process. This gives you time to complete your application with peace of mind, knowing that your rate and monthly payment won’t change due to market movements.",
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
        ],
      },
      {
        id: "can-i-choose-a-different-rate-or-loan-product-after-i-lock",
        question: "Can I choose a different rate or loan product after I lock?",
        answer:
          "Yes. You’ll be locking in all the loan products you see when viewing “Today’s rates”. This means you can change your rate, your rate type (fixed vs. adjustable), or your loan term (15, 20, 30 yr.) up until you close.",
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "what-if-i-need-to-break-my-lock",
        question: "What if I need to break my lock?",
        answer:
          "You are free to withdraw your application and break your lock at any time. There is no fee for doing so. However, you won’t be able to lock a rate with us for the same property for 30 days.",
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
        ],
      },
      {
        id: "what-if-my-lock-expires-before-my-loan-is-complete",
        question: "What if my lock expires before my loan is complete?",
        answer:
          "We will extend your lock if it expires before your loan closes. If the loan delay was caused due to any complications on our end, we will waive the lock extension fee.",
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
        ],
      },
    ],
    videos: [
      {
        id: "rate-lock",
        title: "Why do I need to lock a rate",
      },
    ],
  },
  {
    id: "home-purchase-loan-costs",
    title: "Home purchase loan costs",
    meta_category: "",
    faq: [
      {
        id: "where-can-i-get-a-cost-estimate",
        question: "Where can I get a cost estimate?",
        answer:
          '<p>You can <a href="/mortgage-rates/purchase" target="_blank" rel="noopener noreferrer">check today’s rates</a> for a quick estimate of third-party fees. Once you find a property and <a href="/preapprovals/purchase" target="_blank" rel="noopener noreferrer">get pre-approved</a>, we will provide you with an official Loan Estimate.</p>',
        videos: [
          {
            id: "shopping-for-a-home",
            title: "I need to get pre-approved",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "does-better-charge-lender-fees",
        question: "Does Better charge lender fees?",
        answer:
          "<p>Better does not charge lender fees, so there are no loan officer commissions, lender origination fees, application fees, or underwriting fees. Our investors pay us a one-time fee when they purchase the loan.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        id: "how-much-will-it-cost-me-to-buy-a-home",
        question: "How much will it cost me to buy a home?",
        answer:
          '<p>Great question. Here are the upfront costs to expect when you purchase a home:</p><ol>  <li><strong>Down payment</strong>: This is the portion of the purchase price you agree to cover.</li>  <li><strong>Third-party fees</strong>: These are fees paid to third parties, not Better. These services are required to get a purchase loan no matter which lender you use and we don’t mark up the prices. Some of those fees may be paid by the seller. Examples include the appraisal fee, title insurance, and transfer taxes.    <ul>      <li><a href="/faq/home-purchase-loan-costs/which-third-party-fees-will-i-be-charged">Which third-party fees will I be charged?</a></li>      <li><a href="/faq/home-purchase-loan-costs/which-third-party-fees-does-the-seller-pay">Which third-party fees does the seller pay?</a></li>    </ul>  </li>  <li><strong>Escrow deposit</strong>: If you choose to pay for your homeowner’s insurance and taxes as part of your monthly loan payments, you will need to pay an initial deposit so the account can cover future payments. The number of months required will depend on when these items are due for payment relative to your closing date.</li>  <li><strong>Pre-paid interest</strong>: This is a one-time upfront interest payment due at closing. It covers interest from the day of closing through the end of the month.</li>  <li><i>(optional)</i> <strong>Loan points</strong>: We allow you to get a lower interest rate by paying “points”. In our quotes you’ll see this labeled as “Today’s price for this rate.”</li></ol><p>You can <a href="/mortgage-rates/purchase" target="_blank" rel="noopener noreferrer">check today’s rates</a> for a quick estimate of third-party fees. Once you find a property and <a href="/preapprovals/purchase" target="_blank" rel="noopener noreferrer">get pre-approved</a>, we will provide you with an official Loan Estimate.</p>',
        videos: [
          {
            id: "shopping-for-a-home",
            title: "I need to get pre-approved",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "when-will-i-need-to-pay-these-costs",
        question: "When will I need to pay these costs? ",
        answer:
          "<p>After your offer is accepted and you sign a purchase agreement, you will pay an earnest money deposit. This shows the seller you are serious about the transaction and typically ranges from 1-2% of the purchase price. This deposit will be applied toward your down payment.</p><p>At closing, you will be expected to pay for all remaining costs, including the down payment, third-party fees, and pre-paid costs.</p>",
      },
      {
        id: "which-third-party-fees-will-i-be-charged",
        question: "Which third-party fees will I be charged?",
        answer:
          '<p>Here are the third-party fees associated with a home purchase loan. This does not include other costs that might be negotiated into your purchase contract (ex: pest inspection fee).</p><ol>  <li><strong>Appraisal fee</strong>: A home appraisal must be done by a licensed appraiser to determine the value of the property. You will get a copy of the report.</li>  <li><strong>Credit report</strong>: We need to check your credit in order to determine your creditworthiness and monthly debt obligations.</li>  <li><strong>Flood certification</strong>: We need to determine if your property is in a flood zone to ensure appropriate insurance coverage is in place.</li>  <li><strong>Lender’s title insurance</strong>: This fee ensures we’re protected if someone later makes a claim against the title of the property.</li>  <li><strong>Other title fees</strong>: You will see several miscellaneous title fees. These are charged by the title company for things such as document processing and paying the notary.</li>  <li><strong>Real estate transfer taxes</strong>: Local and state governments charge a transfer tax when real-estate is sold.</li>  <li><strong>Recording fees</strong>: A fee charged by your city or county to officially record the sale.</li>  <li><strong>Settlement</strong>: This fee is paid to the settlement or escrow agent for coordinating the handling and disbursement of funds between the buyer and seller.</li>  <li><i>(optional)</i> <strong>Owner’s title insurance</strong>: This is an optional fee. It ensures you are protected if someone later makes a claim against the title of the property.</li>  </ol><p>You can <a href="/mortgage-rates/purchase" target="_blank" rel="noopener noreferrer">check today’s rates</a> for a quick estimate of the third-party fees you’ll be charged.</p>',
      },
      {
        id: "which-third-party-fees-does-the-seller-pay",
        question: "Which third-party fees does the seller pay? ",
        answer:
          "<p>Regional customs and laws typically determine who pays for what in a home purchase transaction. The seller might pay some of the third-party fees, like the transfer taxes or settlement costs for instance. Consult your real estate agent to determine which party is responsible for each cost.</p>",
      },
      {
        id: "does-better-charge-pre-payment-penalties-purchase",
        question: "Does Better charge pre-payment penalties?",
        answer:
          "<p>No, Better does not originate any loans with a pre-payment penalty.</p>",
      },
    ],
  },
  {
    id: "refinance-loan-costs",
    title: "Refinance loan costs",
    meta_category: "",
    faq: [
      {
        id: "how-much-will-my-closing-costs-be",
        question: "How much will my closing costs be?",
        answer:
          "<p>Your exact closing costs will be based on the circumstances of your loan. To give you a general idea — the majority of our loans from the past year had closing costs between $1,500 and $3,500.</p><p>Closing costs include:</p><ul>  <li>Points or credits, as determined when you select your rate</li>  <li>Third-party settlement fees, which are noted on all loan estimates and disclosures</li>  <li>Per diem, which is pre-paid interest from the day of closing through the end of the month prior to your first payment</li>  <li>Escrow payment, if applicable</li></ul><p>Within 3 days of submitting your application, we’ll send you a loan estimate that outlines your expected closing costs. If anything changes before closing, we’ll send you an updated loan estimate.</p><p>At least 3 days prior to closing, we’ll provide a closing disclosure that gives a fully itemized list of closing costs.</p>",
        videos: [
          {
            id: "points-and-credits",
            title: "What are points and credits?",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "what-fees-and-costs-can-i-expect-with-better",
        question: "What fees and costs can I expect with Better?",
        answer:
          '<p>You can decide whether to pay points up front to buy down your rate, or to take a credit and a higher rate. You’ll see these options when you get a rate quote and can change your selection anytime until you lock your rate. If you are not sure which option is best for you, <a href="/content/no-cost-mortgage/" target="_blank" rel="noopener noreferrer">try our interactive calculator</a>.</p><p>You are also responsible for all third-party settlement fees, which can include independent property appraisal, title services, and recording charges, depending on your circumstances.</p><p>Better does not charge origination fees.</p><p>Your loan estimate, which we will send you within 3 days of submitting your application, will have a breakdown of all fees.</p>',
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "when-will-i-be-expected-to-pay-fees",
        question: "When will I be expected to pay fees?",
        answer:
          "<p>There are three possible fees that you may need to pay before closing. We will not charge any fees until after we have sent you disclosures and you have provided intent to proceed.</p><ol>  <li>Appraisal fee</li>  <ul>    <li>The vast majority of borrowers need to pay a third-party appraisal fee.</li>    <li>The amount is $500.</li>    <li>This fee will be charged around the time you lock your rate.</li>    <li>The only time the appraisal fee is not required is in some refinance situations, if the investor allows a Property Inspection Waiver (PIW). The PIW fee is typically around $175.</li>  </ul>  </ol><p>All other fees will be paid at closing. We’ll send you a loan estimate within 3 days of submitting your application that lists the expected fees. And at least 3 days prior to closing we’ll send you a final closing disclosure that includes the exact breakdown of your closing costs.</p>",
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
      {
        id: "what-will-be-the-payoff-amount-of-my-current-mortgage",
        question: "What will be the payoff amount of my current mortgage?",
        answer:
          "<p>You should continue to pay your current mortgage as scheduled until we close your new loan. We will coordinate with your current mortgage bank prior to closing to determine the final payoff amount. At least 3 days prior to closing, we’ll provide a closing disclosure that gives a fully itemized list of costs, including your loan payoff amount.</p>",
      },
      {
        id: "does-better-charge-pre-payment-penalties-refi",
        question: "Does Better charge pre-payment penalties?",
        answer:
          "<p>No, Better does not originate any loans with a pre-payment penalty.</p><p>To be sure about any fees you will pay, refer to your loan estimate (which we will send you within 3 days of submitting your application) and your closing disclosure (which we will send you at least 3 days before closing). These documents will include information about all expected fees and penalties.</p>",
        videos: [
          {
            id: "loan-estimates",
            title: "Why are loan estimates so important",
          },
        ],
      },
    ],
  },
  {
    id: "pre-approval-letters",
    title: "Pre-approval letters",
    meta_category: "How the process works",
    faq: [
      {
        id: "what-is-a-pre-approval-letter",
        question: "What is a pre-approval letter?",
        answer:
          "<p>A pre-approval letter is a downloadable document from Better stating an exact loan amount you can borrow, assuming certain conditions are met later such as a satisfactory financial review, title report, and appraisal. You can give this letter to your agent and potential sellers to show that you’re serious about buying a home. Obtaining a letter also lets you know what you can afford, so you only spend time viewing properties in your price range.</p>",
      },
      {
        id: "what-types-of-pre-approval-letters-does-better-offer",
        question: "What types of pre-approval letters does Better offer?",
        answer:
          "<p>Better offers two types of letters. The first is a <strong>basic pre-approval letter</strong>. This letter is based on your stated income and a soft credit pull. We have not reviewed any of your documentation. These letters are great for getting a general sense of what you can afford and can be fine to use in certain markets, where agents and sellers don’t require something more fully vetted.</p><p>The second letter Better offers is a <strong>verified pre-approval letter</strong>. You upload financial documents such as paystubs, tax returns, and bank statements for us to review and we determine the amount of qualifying income and assets we can use based on industry guidelines. This letter is great if you want more certainty about what you can afford and if you are buying in a competitive market where agents and sellers require a more fully vetted pre-approval letter.</p>",
      },
      {
        id: "how-do-i-get-a-pre-approval-letter",
        question: "How do I get a pre-approval letter?",
        answer:
          '<p>Go <a href="/preapprovals/purchase" target="_blank" rel="noopener noreferrer">here</a> to get a basic pre-approval letter within 3 minutes. Once you receive that letter, you will be given the option to continue moving forward and get a verified pre-approval letter.</p>',
      },
      {
        id: "how-long-does-it-take-to-get-a-pre-approval-letter",
        question: "How long does it take to get a pre-approval letter?",
        answer:
          "<p>A basic pre-approval letter takes about 3 minutes.</p><p>For a verified pre-approval letter, you will need to upload financial documents such as W2s, paystubs, tax returns, and bank statements. This usually takes about 20 minutes. Then we will review them and generate your letter. We may require additional processing time if the documentation you submitted is incomplete or if we need to verify overtime, bonus, or commission earnings with your employer.</p>",
      },
      {
        id: "how-much-does-it-cost-to-get-a-pre-approval-letter",
        question: "How much does it cost to get a pre-approval letter?",
        answer:
          "<p>Nothing. We will provide you with both a basic and verified pre-approval letter free of charge.</p>",
      },
      {
        id:
          "will-my-verified-pre-approval-letter-look-different-than-my-basic-pre-approval-letter",
        question:
          "Will my verified pre-approval letter look different than my basic pre-approval letter?",
        answer:
          "<p>Yes. Your verified letter will be marked as “Verified” and will note that we have reviewed your documentation and verified certain assets, income, and debt payments.</p>",
      },
      {
        id:
          "is-a-hard-credit-pull-required-to-get-a-verified-pre-approval-letter",
        question:
          "Is a hard credit pull required to get a verified pre-approval letter?",
        answer:
          "<p>Yes. This helps us determine your exact FICO score and monthly debt obligations so we can be sure you qualify for a loan.</p>",
      },
      {
        id: "why-would-my-verified-income-be-different-than-my-stated-income",
        question:
          "Why would my verified income be different than my stated income?",
        answer:
          "<p>The amount of income we verify impacts the total loan amount we can offer you. In some cases, verified income might be lower than stated income. Investor and industry guidelines govern what income we are able to use. Here are a few examples:</p><ol>  <li>    If you earn bonus, commission, or overtime income that hasn’t been consistent over the last 2 years, we may not be able to give you credit for all of it.  </li>  <li>    If you are reporting any self-employment losses on your tax return, they will be deducted from your qualifying income.  </li>  <li>    If self-employment income is declining year-over-year, we have to use the lower amount.  </li>  <li>    If you report rental income, we use the net amount, after subtracting out certain  expenses you have written off on your tax return.  </li>  <li>    If you are using income from alimony or child support, we have to document that it will be received for at least the next 3 years.  </li></ol><p>If you want additional certainty as to the purchase price you qualify for, we recommend getting a verified pre-approval letter. </p>",
      },
      {
        id:
          "why-would-my-verified-assets-that-are-used-to-determine-my-down-payment-be-lower-than-expected",
        question:
          "Why would my verified assets that are used to determine my down payment be lower than expected?",
        answer:
          "<p>We must verify that you have control over the assets you are planning to use for your down payment. There are some cases when verified assets might be lower than you expect. Here are a few examples:</p><ol>  <li>    If you have large deposits in your bank account from an ineligible source (e.g. cash deposit, undocumented source, unsecured loan such as a credit card advance) we will not be able to give you credit for those funds.  </li>  <li>    We are typically only able to use assets from investment and retirement accounts if they are liquidated prior to closing the loan.  </li>  <li>    We are only able to use a percentage of any pending property sale values, and not the full amount.  </li>  <li>    We only consider assets from business accounts on a case by case basis.  </li></ol><p>If you want additional certainty as to the purchase price you qualify for, we recommend getting a verified pre-approval letter.</p>",
      },
      {
        id:
          "who-can-i-contact-if-i-have-questions-about-my-verified-pre-approval-letter",
        question:
          "Who can I contact if I have questions about my verified pre-approval letter?",
        answer:
          "<p>You may contact your assigned Mortgage Expert by email or by phone. You may also schedule a conversation with them at your convenience. The contact details for your assigned Mortgage Expert are located on the top right corner of your screen when you sign in to your loan.</p>",
      },
    ],
    videos: [
      {
        id: "shopping-for-a-home",
        title: "I need to get pre-approved",
      },
    ],
  },
  {
    id: "loan-process",
    title: "Loan process",
    meta_category: "",
    faq: [
      {
        id: "will-i-have-a-point-of-contact-at-better",
        question: "Will I have a point of contact at Better?",
        answer:
          "<p>Yes. As soon as your complete the 3-minute approval process, we’ll introduce you to your loan officer. You can contact your loan officer anytime throughout the process. We provide phone, email, and chat support during much of the week: <ul> <li>Monday-Friday: 9AM - 9PM EST</li> <li>Saturday-Sunday: 10AM - 6PM EST</li> </ul>",
      },
      {
        id: "am-i-committing-to-better-by-getting-pre-approved",
        question: "Am I committing to Better by getting pre-approved?",
        answer:
          "<p>No. Our pre-approval application is a tool for you to understand the types of loans and rates available to you. Completing the pre-approval application does not mean that you’re required to continue with Better.</p>",
        videos: [
          {
            id: "shopping-for-a-home",
            title: "I need to get pre-approved",
          },
        ],
      },
      {
        id: "what-do-i-need-to-do-to-lock-my-rate",
        question: "What do I need to do to lock my rate?",
        answer:
          '<p>After you get pre-approved and select your preferred rate, your application will show you a list of tasks that need to be completed. The first group of tasks is called "Lock your rate"</p><p>Once you complete all the tasks in this group, you’ll be able to request a rate lock. If accepted, you’ll have a period of time in which to complete the remaining work, and your interest rate will be guaranteed.</p>',
        videos: [
          {
            id: "shopping-for-a-home",
            title: "I need to get pre-approved",
          },
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
        ],
      },
      {
        id: "how-quickly-can-i-close-my-loan",
        question: "How quickly can I close my loan?",
        answer:
          "<p>Better usually closes loans between 3-6 weeks after rate lock.</p><p>The exact timing depends on a few factors, including how quickly you can submit all required documents, as well as the timing of third-party services.</p><p>The most common situation that requires a longer time to close is a refinance where the borrower has a second mortgage that needs to be subordinated.</p><p>If your loan happens to have more complicated circumstances and will take longer to close, your loan officer will discuss this with you when it’s time to lock your rate, and you may agree to a longer lock period.</p>",
        videos: [
          {
            id: "rate-lock",
            title: "Why do I need to lock a rate",
          },
        ],
      },
      {
        id: "do-i-need-to-have-an-escrow-account",
        question: "Do I need to have an escrow account?",
        answer:
          "<p>An escrow account is not required for most borrowers. However, having an escrow account usually helps in getting the best rate and maintaining your peace of mind.</p><p>If you choose to have an escrow account:</p><ul>  <li>The annual amount of your property taxes and homeowners insurance will be divided by 12.</li>  <li>Your monthly mortgage payment will be increased by this amount.</li>  <li>Your mortgage provider will pay your taxes and insurance for you out of the escrow account.</li>  <li>Your total payments are the same, and you may get a better rate.</li></ul><p>Without an escrow account, you are responsible for paying your tax and insurance bills directly.</p>",
      },
      {
        id: "can-i-transfer-my-current-escrow-account",
        question: "Can I transfer my current escrow account?",
        answer:
          "<p>No. Any balance in your current escrow account at the time of new loan funding will be refunded to you by your current mortgage servicer. This typically happens within 3 weeks from time of closing.</p>",
      },
      {
        id: "is-my-data-secure",
        question: "Is my data secure?",
        answer:
          '<p>The security of your data is our highest priority. All information transmitted to and from our website is encrypted in line with industry standards. In addition, we have in place physical, technical, and administrative security measures to protect personal information against loss, misuse, unauthorized access, or improper disclosure. For more details, please refer to our <a href="/about-us/privacy-policy" data-qa="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</p>',
      },
    ],
  },
  {
    id: "credit-scores",
    title: "Credit scores",
    meta_category: "",
    faq: [
      {
        id: "how-does-my-credit-score-affect-my-mortgage",
        question: "How does my credit score affect my mortgage?",
        answer:
          "<p>Your credit score helps lenders evaluate your ability to pay back your loans, based on your borrowing history. The higher your credit score, the better rates you’ll be able to get. This can lead to significant savings over the life of your mortgage.<p>",
      },
      {
        id: "how-can-i-get-my-credit-report",
        question: "How can I get my credit report?",
        answer:
          '<p>While there are many online resources, Better does not endorse any one in particular. The Federal Trade Commission offers more information, including how you can get one free copy of your credit report every 12 months from each of the three nationwide credit reporting companies. Please visit this link for more info: <a href="https://www.ftc.gov/faq/consumer-protection/get-my-free-credit-report" target="_blank" rel="noopener noreferrer">https://www.ftc.gov/faq/consumer-protection/get-my-free-credit-report</a></p>',
      },
      {
        id: "what-is-a-soft-credit-check",
        question: "What is a soft credit check?",
        answer:
          "<p>When you apply online for our 3-minute basic pre-approval, we’ll ask for your social security number and do a secure “soft” credit check. This doesn’t affect your credit score in any way. We use your FICO Classic 04 credit score from Transunion. Knowing your credit score helps us make make more accurate calculations about how much you can afford.</p>",
      },
      {
        id: "what-is-a-hard-credit-check",
        question: "What is a hard credit check?",
        answer:
          "<p>For a “hard credit check” we use the median score from Transunion, Experian, and Equifax. This signifies to credit bureaus that you are interested in opening a new line of credit, and will have a small impact on your credit score (usually less than five points).</p>",
      },
      {
        id: "what-if-i-think-my-score-is-incorrect",
        question: "What if I think my score is incorrect?",
        answer:
          "<p>If you think there’s a mistake in your credit score, contact Transunion directly at 1 (855) 681-3196.</p>",
      },
      {
        id: "what-if-i-dont-recognize-a-credit-line-thats-listed-on-my-report",
        question:
          "What if I don't recognize a credit line that's listed on my report?",
        answer:
          "<p>In many cases, credit lines have unrecognizable labels. If you’ve reviewed and accounted for all your debts and still think a credit line is incorrect, please schedule a call with your Mortgage Expert. We cannot resolve the problem without getting more information from you.</p>",
      },
      {
        id: "how-do-multiple-credit-checks-work",
        question: "How do multiple credit checks work?",
        answer:
          "<p>If you are shopping around with different lenders, credit bureaus will typically only dock your score once within a 30-day period, no matter how many mortgage lenders do a credit check. That means if you’ve already done a hard credit check with another lender but want to switch to Better, it won’t impact your score.</p>",
        videos: [
          {
            id: "who-is-better",
            title: "A quick overview",
          },
        ],
      },
      {
        id: "how-do-you-choose-which-credit-score-to-use",
        question: "How do you choose which credit score to use?",
        answer:
          "<p>During pre-approval, we use the FICO Classic 04 credit score from Transunion. This is a soft credit check and won't affect your credit score. If you apply with a co-borrower, we use the lower of your two scores.</p><p>When you want to continue with your loan application, with your authorization we pull your credit scores from all three major credit bureaus (Transunion, Experian, and Equifax) and use the median of the three scores received.</p>",
      },
      {
        id: "what-if-im-applying-with-a-co-borrower",
        question: "What if I’m applying with a co-borrower?",
        answer:
          "<p>We have to use the lower credit score of you and your co-borrower. If one of you has a low credit score, we often recommend that the person with the higher credit score apply to get the best terms possible. You’ll still be able to put both names on the title. However both people may need to apply if more funds are needed for your down payment, or to improve your debt to income ratio.</p>",
      },
      {
        id: "is-my-credit-score-too-low-to-apply",
        question: "Is my credit score too low to apply?",
        answer:
          "<p>We can currently only provide loans to customers with a credit score of 620 or above. If your score improves, let us know, we’d love work with you.</p>",
      },
    ],
  },
  {
    id: "appraisals",
    title: "Appraisals",
    meta_category: "",
    faq: [
      {
        id: "what-is-an-appraisal",
        question: "What is an appraisal?",
        answer:
          "<p>An appraisal is an <i>opinion</i> of value based on market data from your neighborhood.</p>",
      },
      {
        id: "why-do-i-need-an-appraisal",
        question: "Why do I need an appraisal?",
        answer:
          "<p>How much money you can borrow is in part determined by the value of the collateral provided, which is your home. An appraisal is needed to determine the value of your home.</p>",
      },
      {
        id: "can-i-use-or-transfer-a-recent-appraisal",
        question: "Can I use or transfer a recent appraisal?",
        answer:
          "<p>Unfortunately, no. When applying for a new mortgage it is always the lender that must order the appraisal report, and we do not accept appraisal transfers from other mortgage transactions.</p>",
      },
      {
        id: "i-know-an-appraiser-can-he-or-she-complete-my-appraisal-report",
        question:
          "I know an appraiser. Can he or she complete my appraisal report?",
        answer:
          "<p>Unfortunately, no. The lender must choose the appraiser. In the event the appraiser selected by the lender is an appraiser that you know, that appraiser must disclose the nature of your relationship in the appraisal report.</p>",
      },
      {
        id: "how-long-does-an-appraisal-inspection-take",
        question: "How long does an appraisal inspection take?",
        answer:
          "<p>The appraisal inspection takes approximately 10 minutes per 1,000 square feet. Therefore a 2,000 square foot home will take approximately 20 minutes to inspect.</p>",
      },
      {
        id: "what-is-the-difference-between-a-home-inspection-and-an-appraisal",
        question:
          "What is the difference between a home inspection and an appraisal?",
        answer:
          "<p>An appraisal provides an estimate of value. A home inspection comments on the structural soundness of your home and the components within it, such as the furnace and water heater.</p>",
      },
      {
        id: "how-does-the-appraiser-determine-the-value-of-my-home",
        question: "How does the appraiser determine the value of my home?",
        answer:
          "The appraiser compares your home to other properties in the area and makes adjustments for differences.",
      },
      {
        id:
          "if-the-appraised-value-of-my-home-goes-up-will-this-affect-my-taxes",
        question:
          "If the appraised value of my home goes up, will this affect my taxes?",
        answer:
          "<p>No, it will not affect your taxes. The appraiser does not report the appraised value or anything they see in the home (e.g., illegal decks or additions, converted garages, etc.) to the tax assessor.</p>",
      },
      {
        id: "what-does-an-appraisal-report-look-like",
        question: "What does an appraisal report look like?",
        answer:
          '<p>Depending on the property type, an appraiser will prepare a specific report.</p><ul>  <li>Single family homes: <a href="https://www.fanniemae.com/content/guide_form/1004.pdf" target="_blank" rel="noopener noreferrer">Uniform Residential Appraisal Report</a></li>  <li>Condominiums: <a href="https://www.fanniemae.com/content/guide_form/1073.pdf" target="_blank" rel="noopener noreferrer">Individual Condominium Unit Appraisal Report</a></li>  <li>Multi-family homes: <a href="https://www.fanniemae.com/content/guide_form/1025.pdf" target="_blank" rel="noopener noreferrer">Small Residential Income Property Appraisal Report</a></li></ul><p>A copy of your appraisal report will be shared with you once we receive it.</p>',
      },
      {
        id: "which-home-improvements-add-value-to-a-home",
        question: "Which home improvements add value to a home?",
        answer:
          "<p>Valuing a house is more of an art than a science. However, there are rooms you want to pay more attention to than others. The general rule of thumb is kitchen and baths have the greatest return on investment. Highly individualized finishes, such as high-end toilets or expensive media rooms, have lower returns.</p>",
      },
    ],
  },
  {
    id: "loan-servicing",
    title: "Loan servicing",
    meta_category: "",
    faq: [
      {
        id: "how-will-my-loan-be-serviced-after-closing",
        question: "How will my loan be serviced after closing?",
        answer:
          "<p>Better will service your loan for a short period after it closes, usually about 30 days. During this time, payment administration and collection will be handled by our servicing partner, called LoanCare.</p><p>After that, we will transfer your loan to a permanent servicer. We have a large roster of reputable servicers and mortgage investors including major US banks, government-sponsored entities, publicly-traded mortgage companies, and specialized servicing firms. We collect third-party reviews and survey our borrowers post-transfer to ensure the permanent servicers are quality partners.</p>",
      },
      {
        id: "i-thought-better-is-a-direct-lender-not-a-broker",
        question: "I thought Better is a direct lender, not a broker",
        answer:
          '<p>What a broker does is sell your loan <i>application</i> to another lender. We don’t do that.</p><p>As a direct lender, we process your application, underwrite, close, and fund your loan. We access the capital markets to find you the lowest rate possible and match you to the investor who best matches your loan profile. We take 100% responsibility for the entire process, including making sure the transfer to your permanent servicer goes smoothly.</p><p>Our goal is to provide full transparency. You can always ask your loan officer about your loan’s permanent servicer, or email <a href="mailto:servicing_inquiries@better.com">servicing_inquiries@better.com</a>.</p>',
      },
      {
        id: "how-do-i-make-my-first-payment",
        question: "How do I make my first payment?",
        answer:
          "<p>After your loan closes, you will receive instructions by email and in writing on where to direct your first payment.</p><p>In some cases, your first payment will be made to us. In others, your loan may be transferred quickly enough that your first payment will be to the permanent servicer.</p><p>Official notification of your transfer and new payment instructions will come via US mail, and should arrive no fewer than 10 calendar days before your payment is due to your permanent servicer.</p>",
      },
      {
        id: "can-i-set-up-automatic-payments-with-better",
        question: "Can I set up automatic payments with Better?",
        answer:
          "<p>We recommended making a one-time payment, as your loan will very likely be transferred to a permanent servicer before the second payment is due.</p>",
      },
      {
        id: "will-better-help-me-if-there-are-concerns-with-my-transfer",
        question: "Will Better help me if there are concerns with my transfer?",
        answer:
          "<p>Yes, of course. Email <a href='mailto:servicing_inquiries@better.com'>servicing_inquiries@better.com</a>. We will get in touch with the permanent servicer and resolve the issue on your behalf.</p>",
      },
    ],
  },
]
